import { Action, ThunkAction } from '@reduxjs/toolkit'
import { Company } from '../../../types/company/Company'
import { setContextContract } from '../contract/actions'
import { updateDimensionFilterAction } from '../filters/actions'
import { SET_CONTEXT_COMPANY } from './types'
import { getCompanyChartColorsRequest, getCompanySettingsRequest } from '../companySettings/actions'
import { contextRequest } from '../actions'
import { Store } from '../../types'
import { currentUserDimensionSelector, currentUserPermissionSelector } from '../../session/currentUser/selectors'

export const setContextCompany = (payload: Company): ThunkAction<void, Store, null, Action<string>> => {
  return (dispatch, getState) => {
    const store: Store = getState()
    const dimensions = currentUserDimensionSelector(store)
    const permissions = currentUserPermissionSelector(store)

    const { contract, ...company } = payload
    dispatch(getCompanyChartColorsRequest(company.id))
    dispatch({ type: SET_CONTEXT_COMPANY, payload: company })
    contract && dispatch(setContextContract(contract))
    const dimension = dimensions.find(d => d.companyId === company.id)
    if (!permissions.find(p => p.label === 'read-root-dimension') && dimension) {
      dispatch(updateDimensionFilterAction([dimension.dimensionId]))
    }
    dispatch(contextRequest(getCompanySettingsRequest))
  }
}
